

import seoTags from "@/mixins/seoTags";
import { mapMutations } from "vuex";

export default {
	mixins: [seoTags],
	// validate(ctx) {
	// 	return ctx.params.category === 'cars';
	// },
	mounted() {
		 window.scrollTo(0, 0)

		if (!this.$device.isMobile) {
			// setTimeout(function () { window.scrollTo(0, 180); }, 2);
		}
		localStorage.removeItem('foldersTabsLeft');
	},
}
